/**
 * Define common mixin
 *
 * @author minkyoung.park@emcast.com
 */


import i18nApi from '@/api/i18nApi.js'

export const commonMixin = {
    data() {
        return {

        }
    },
    created() {

    },

    methods: {
        // 부모 라우터로 이동(move parent route)
        moveParentRouter() {
            let routerLen = this.$route.matched.length
            // console.log('moveParentRouter', this.$route.matched, routerLen)
            if (routerLen === 1) {
                this.$router.push({
                    name: 'Home'
                })
            } else {
                let query = this.$route.query
                this.$router.push({
                    name: this.$route.matched[routerLen - 2].name,
                    query: query
                })
            }
        },
        // Coming from Mobile app.
        callPushNotification() {
            if (localStorage.getItem("fbToken") !== "undefined") {
                let params = {
                    options: {
                        pushToken: localStorage.getItem("fbToken"),
                        pushLanguage: JSON.parse(localStorage.getItem("languageInfo")) && JSON.parse(localStorage.getItem("languageInfo")).code ? JSON.parse(localStorage.getItem("languageInfo")).code : "en",
                    },
                };
                i18nApi.callPushNotificationApi(params).then((response) => {
                    let responseData = response.data.data;
                    // console.log("api has called from mixins", responseData);

                    // localStorage.setItem("justfortesting", responseData.options.pushToken);
                });
            }
        },
    }
}